<template>
  <div>
    <b-dropdown id="dropdown-1" :text="text" class="my-md-2 company-picker ui-dashboard-menu-dropdown" variant="company-picker">
      <b-dropdown-item v-for="a_company in profile_companies" :key="a_company[0].id" :active="a_company[0].id==company_id" @click="redirect(a_company[0].id)">{{a_company[0].name}}</b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <div v-if="accounting_clients.length > 0">
        <b-dropdown-item v-for="a_company in accounting_clients" :key="a_company.id" :active="a_company.id==company_id" @click="redirect(a_company.id)">{{a_company.name}}</b-dropdown-item>
      </div>
      <div v-else>
        <b-dropdown-item @click="addCompany()">
          <font-awesome-icon icon="fa-solid fa-plus" /><span v-translate>Add company profile</span></b-dropdown-item>
      </div>
    </b-dropdown>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import CompanyService from "@/store/services/company.service.js";

export default {
  name: "CompanyPicker",
  components: {},
  data() {
    return {
      company_id: '',
      profile_companies: [],
      accounting_clients: [],
      text: '',
    }
  },
  computed: {
    ...mapGetters({ 
      getCompanyId: 'main/getCompanyId',
    })
  },
  created () {
    this.setupData()
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'main/SET_CURRENT_COMPANY') {
        this.setupData()
      }
    })
  },
  destroyed () {
    this.unsubscribe()
  },
  methods: {
    ...mapActions({ 
      switchCompany: 'main/switchCompanyProfile'
    }),
    setupData () {
      this.company_id = this.getCompanyId
      CompanyService.companyPickerOptions().then((response) => {
        this.profile_companies = response.data['profile_companies']
        this.accounting_clients = response.data['accounting_clients']

        let currentCompany = this.profile_companies.find(company => company[0].id == this.company_id)

        if (!currentCompany) {
          currentCompany = {}
          currentCompany[0] = this.accounting_clients.find(customer => customer.id == this.company_id)
          currentCompany[1] = true // an accountant has access to their customer
        }

        this.text = currentCompany[0]['name']
      })
    },
    redirect(target_company){
      this.switchCompany(target_company)
    },
    addCompany(){
      this.$router.push({ name: 'CreateCompany' });
    },
    isAccountingClient(company_id) {
      return this.accounting_clients.map(x => x.id).includes(company_id)
    }
  }
};
</script>
<style lang="scss">

.company-picker {
  .btn-company-picker {
    color: #eb8d36;
    box-shadow: none !important;
    border: none !important;
    background: none !important;
    padding-left: 0 !important;
  }
  .dropdown-menu {
    li {
      .dropdown-item.active { 
        color: $colorTextBase;
        background-color: transparent; 
      }
    }
  }
}

</style>